import { ThirdParty } from "project-config/constants/third-party";
export function getBindAccountList(data: any[]) {
  // 账号-微信/QQ： 一对一
  const qqItem = data.find((item) => item.fromWhere === ThirdParty.QQ) || {
    fromWhere: ThirdParty.QQ,
  };
  const weChatItem = data.find(
    (item) => item.fromWhere === ThirdParty.WeChat
  ) || { fromWhere: ThirdParty.WeChat };
  return [qqItem, weChatItem];
}
